import React, { Component } from "react";
import { HoveredWidget } from "../components/HoveredWidget";
import Users from "./Users/Users";
import { ViewFilterDropdown } from "./Users/Users";
import { merchantApiService } from "../services/api/merchants/MerchantApiService";
import { DashboardMetrics } from "../models/DashboardMetrics";
import { AppCard, PageLayout } from "../components/ui";
import { Users as UsersIcon, ArrowRight, UserCheck, UserSearch, LayoutDashboard } from "lucide-react";
import type { ViewFilter } from "./Users/Users";

interface DashboardState {
    metrics: DashboardMetrics;
    isLoading: boolean;
    usersView: ViewFilter;
}

export default class Dashboard extends Component<Record<string, never>, DashboardState> {
    constructor(props: Record<string, never>) {
        super(props);

        this.state = {
            isLoading: true,
            usersView: "individuals",
            metrics: {
                totalUsers: 0,
                newUsers: 0,
                usersPendingApproval: 0,
                totalUsersApproved: 0,
            },
        };
    }

    componentDidMount(): void {
        this.loadMetrics();
    }

    loadMetrics = async () => {
        const metricsResult = await merchantApiService.getMetrics();

        if (!metricsResult.success) {
            this.setState({ isLoading: false });
            return;
        }

        this.setState({ metrics: metricsResult.data, isLoading: false });
    };

    renderWidgets = () => {
        return (
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4 py-5">
                <HoveredWidget
                    textClass="success"
                    icon={UsersIcon}
                    description=""
                    title={`${this.state.metrics.totalUsers}`}
                    subHeading="Total Number of Customers"
                    isLoading={this.state.isLoading}
                />

                <HoveredWidget
                    textClass="info"
                    icon={UsersIcon}
                    arrowIcon={ArrowRight}
                    description="Last 24 Hours"
                    title={`${this.state.metrics.newUsers}`}
                    subHeading="New Customers"
                    isLoading={this.state.isLoading}
                />

                <HoveredWidget
                    textClass="danger"
                    icon={UserSearch}
                    title={`${this.state.metrics.usersPendingApproval}`}
                    subHeading="Customers Pending Approval"
                    isLoading={this.state.isLoading}
                />

                <HoveredWidget
                    textClass="warning"
                    icon={UserCheck}
                    description=""
                    title={`${this.state.metrics.totalUsersApproved}`}
                    subHeading="Total KYC Approvals"
                    isLoading={this.state.isLoading}
                />
            </div>
        );
    };

    render() {
        return (
            <PageLayout heading="Dashboard" icon={LayoutDashboard}>
                {this.renderWidgets()}
                {/* <Card>
                    <CardHeader>
                        Transactions
                    </CardHeader>
                    <CardBody>
                        <UserTransactions userId={null} showExpander={false} />
                    </CardBody>
                </Card> */}
                <AppCard>
                    <AppCard.Header
                        title="Customers"
                        actions={<ViewFilterDropdown activeView={this.state.usersView} onChange={(view) => this.setState({ usersView: view })} />}
                    />
                    <AppCard.Body className="!p-0">
                        <Users merchantId={null} isDashboard={true} activeView={this.state.usersView} />
                    </AppCard.Body>
                </AppCard>
            </PageLayout>
        );
    }
}
